/* ------------------------------------------------------------------
  File: footerConfig.js
  Author: Engr. Shaffa K. Kokro Jr. - CEO, Accend Holdings Ltd.
  Last Modified: 2026-07-10
------------------------------------------------------------------ */

// Purpose:
//   - footerConfig defines the global footer content and link structure.
//   - It centralizes footer navigation columns, related sites, social links,
//     legal links, and footer-specific display settings.
//   - All internal route values should come from routesConfig or routeBuilders
//     to maintain a single source of truth for application paths.

import { siteConfig } from "./siteConfig";
import { routesConfig } from "./routesConfig";

import footerLogo from "../../assets/images/accend-holdings-logo-new-black-colored.png";

export const footerConfig = {
  brand: {
    name: siteConfig.name,
    shortName: siteConfig.shortName,
    logo: footerLogo,
  },

  columns: [
    {
      title: "About Us",
      links: [
        {
          label: "Company",
          to: routesConfig.about,
        },
        {
          label: "Leadership",
          to: routesConfig.aboutLeadership,
        },
        {
          label: "Governance",
          to: routesConfig.aboutGovernance,
        },
        {
          label: "Partnerships",
          to: routesConfig.aboutPartnerships,
        },
      ],
    },

    {
      title: "Businesses",
      links: [
        {
          label: "Group Companies",
          to: routesConfig.businessesGroupCompanies,
        },
        {
          label: "Operating Sectors",
          to: routesConfig.businessesOperatingSectors,
        },
        {
          label: "Our Portfolio",
          to: routesConfig.businessesPortfolioOverview,
        },
      ],
    },

    {
      title: "Useful Links",
      links: [
        {
          label: "Investors",
          to: routesConfig.investorsOverview,
        },
        {
          label: "Careers",
          to: routesConfig.investorsStrategicCapital,
        },
        {
          label: "Newsroom",
          to: routesConfig.newsroom,
        },
        {
          label: "Contact",
          to: routesConfig.investorsImpactReturns,
        },
      ],
    },
  ],

  relatedSites: {
    title: "Related Sites",
    links: [
      {
        label: "Accend Group™",
        href: "https://www.accend.cc",
        external: true,
      },
      {
        label: "Accend Business™",
        href: "https://business.accend.cc",
        external: true,
      },
      {
        label: "Accend Partners™",
        href: "https://partners.accend.cc",
        external: true,
      },
    ],
  },

  socialLinks: [
    {
      label: "LinkedIn",
      href: siteConfig.socialLinks.linkedin,
      external: true,
      icon: "linkedin",
    },
    {
      label: "Facebook",
      href: siteConfig.socialLinks.facebook,
      external: true,
      icon: "facebook",
    },
    {
      label: "Instagram",
      href: siteConfig.socialLinks.instagram,
      external: true,
      icon: "instagram",
    },
    {
      label: "X",
      href: siteConfig.socialLinks.x,
      external: true,
      icon: "x",
    },
    {
      label: "YouTube",
      href: siteConfig.socialLinks.youtube,
      external: true,
      icon: "youtube",
    },
  ],

  legalLinks: [
    {
      label: "Privacy",
      to: routesConfig.privacyPolicy,
    },
    {
      label: "Terms of use",
      to: routesConfig.termsOfUse,
    },
    {
      label: "Cookies Policy",
      to: routesConfig.cookies,
    },
    {
      label: "Sitemap",
      to: routesConfig.sitemap,
    },
  ],

  credit:
    "Designed & developed by Engr. Shaffa K. Kokro Jr. | Accend Technologies Ltd.",

  copyright: {
    text: "All Rights Reserved.",
    company: siteConfig.name,
    startYear: 2026,
  },
};